<script>
    import $device from '../../global/device';
    import $markdown from '../../global/markdown';
    import icon_error from '../../icon/misc/error.svg';
    import icon_ok from '../../icon/misc/ok.svg';

    const icon = {
        error: icon_error,
        ok: icon_ok
    };

    /**
     * This is a snackbar message container. It is typically generated using [$notify](#/global/notify), which will
     * dock it to a window side.
     */
    export default {
        name: 'snackbar',

        props: {
            msg: String,
            tone: String,
            action: Array,
            timeout: Number
        },

        beforeDestroy() {
            this.clear();
        },

        render(h) {
            return h('div', {
                'staticClass': '_sbar'
            }, [
                icon[this.tone] ? h('div', {
                    'staticClass': '_sbar-icon',
                    'class': 'fg-' + this.tone,
                    'domProps': {
                        'innerHTML': icon[this.tone]
                    }
                }) : void 0,
                h('div', {
                    'staticClass': '_sbar-msg',
                    'domProps': {
                        'innerHTML': $markdown.toHTML(this.msg)
                    }
                }),
                this.action || $device.mouse ? h('div', {
                    'staticClass': '_sbar-act'
                }, (this.action || [{
                    label: this.$t('Dismiss'),
                    click: this.dismiss
                }]).map(action => h('ib-button', {
                        'attrs': {
                            'tone': action.tone || 'accent',
                            'appearance': 'clear'
                        },
                        'on': {
                            'click': () => { this.dismiss(action.click) }
                        }
                    }, action.label))
                ) : void 0
            ]);
        },

        watch: {
            timeout: {
                handler(timeout) {
                    this.clear();
                    this.to = setTimeout(this.dismiss, timeout - Date.now());
                },
                immediate: true
            }
        },

        methods: {
            dismiss(action) {
                this.clear();
                this.$emit('dismiss');
                if (action) {
                    action();
                }
            },

            clear() {
                if (this.to) {
                    clearTimeout(this.to);
                    this.to = 0;
                }
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._sbar {
        position: relative;
        display: flex;
        margin: 8px;
        padding: @snackbar-padding;
        background-color: @bg-tooltip;
        color: @fg-tooltip;
        border-radius: @snackbar-border-radius;
        min-width: @snackbar-min-width;
        max-width: @snackbar-max-width;
        align-items: center;
        flex-wrap: wrap;
        visibility: visible;
        transition: opacity .3s, transform .3s;
        .snackbar();

        &-icon {
            padding: @snackbar-icon-padding;
            > svg {
                width: 40px;
                height: 40px;
            }
        }
        &-msg {
            padding: 8px;
            flex: 1 1 auto;
        }
        &-act {
            display: flex;
            flex: 1 1 auto;
            justify-content: flex-end;
        }

        ._btn {
            margin: 0;
            padding: 8px;
            max-width: none;
            height: auto;
            line-height: 1;
            font-weight: 500;
            &.accent {
                color: @fgdark-accent !important;
            }
        }
    }
</style>
